import AuthProvider from "./context/AuthProvider";
import Main from "./Main";
import { BrowserRouter } from 'react-router-dom';

function App() {

  return (
/*
    <AuthProvider>
      <Main/>
    </AuthProvider>
*/
    <BrowserRouter>
      <AuthProvider>
        <Main />
      </AuthProvider>
    </BrowserRouter>
  );

}

export default App;
